import React, { useEffect, useState } from "react";
import axios from "axios";
import _ from "lodash";
import LoadingDiv from "../../components/LoadingDiv";
import { Config } from "../../Config";
import BrandLogo from "../../assets/image/brandlogo.png";
import ContentWrapper from "../../components/ContentWrapper";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "react-feather";
const PublicPrivacyPolicy = () => {
  const navigate = useNavigate();
  const [privacyPolicyData, setPrivacyPolicyData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);

    axios
      .get(`${Config.BaseUrl}/public/services/v1/privacy-policy`)
      .then((res) => {
        if (res.status === 200) {
          setPrivacyPolicyData(res?.data);
        } else {
          setPrivacyPolicyData({});
        }
        setLoading(false);
      })
      .catch((err) => {
        setPrivacyPolicyData({});
        setLoading(false);
      });
  }, []);

  return (
    <ContentWrapper>
      {loading ? (
        <div className="m-5 p-5 ">
          <LoadingDiv/>
        </div>
      ) : (
        <div className="w-full md:w-[80%] mx-auto">
          <div
            className="h2 inline-block cursor-pointer"
            onClick={() => {
              navigate("/login");
            }}
          >
            <ArrowLeft/>
          </div>
          <div className="d-flex justify-content-center m-2 p-2">
            <img src={BrandLogo} alt="logo" className="w-40 mx-auto !my-6" />
          </div>
          <h4 className="text-center text-xl md:text-2xl">Privacy Policy</h4>

          <div className="bg-white p-1 md:p-2 rounded-lg border border-gray-100 mt-4">
            {!_.isEmpty(privacyPolicyData) && (
              <div className="card-body m-3 p-3">
               {privacyPolicyData?.data?.length > 0 ? <pre
                  style={{
                    whiteSpace: "pre-line",
                    fontSize: "16px",
                    fontFamily: "Poppins ,sans-serif",
                  }}
                >
                  {privacyPolicyData?.data[0]?.status * 1 === 1 &&
                    privacyPolicyData?.data[0]?.public * 1 === 1 &&
                    privacyPolicyData?.data[0]?.posts?.content}
                </pre> : <p className="text-center text-gray-500 text-sm">No Data Found</p>}
              </div>
            )}
          </div>
        </div>
      )}
    </ContentWrapper>
  );
};

export default PublicPrivacyPolicy;
